export interface TutorialStepData {
  key: TutorialStep;
  title: string;
  src: string;
  description: string;
}

export enum TutorialStep {
  Corners = 'corners',
  Light = 'light',
  Focus = 'focus',
}

export const tutorialStepsData: TutorialStepData[] = [
  {
    key: TutorialStep.Corners,
    title: 'my-documents.upload.tutorial.corners.title',
    src: 'assets/img/my-documents/upload-tutorial/corners.svg',
    description: 'my-documents.upload.tutorial.corners.description',
  },
  {
    key: TutorialStep.Light,
    title: 'my-documents.upload.tutorial.light.title',
    src: 'assets/img/my-documents/upload-tutorial/light.svg',
    description: 'my-documents.upload.tutorial.light.description',
  },
  {
    key: TutorialStep.Focus,
    title: 'my-documents.upload.tutorial.focus.title',
    src: 'assets/img/my-documents/upload-tutorial/focus.svg',
    description: 'my-documents.upload.tutorial.focus.description',
  },
];
